<template>
  <div class="beneficiary-container">
    <div>
      <div class="add-member-area">
        <el-button type="primary" size="small" @click="addCustomer()"
          >Add Customer</el-button
        >
      </div>
      <el-tabs v-model="tabActive" type="border-card">
        <el-tab-pane label="Beneficiary Pending" name="pending">
          <BeneficiaryPending  ref="BeneficiaryPending" />
        </el-tab-pane>
        <el-tab-pane label="Beneficiary Customer" name="customer">
          <BeneficiaryCustomer ref="BeneficiaryCustomer"/>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog 
    title="Add Customer" 
    :visible.sync="dialogAddCutomer" 
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    >
      <el-form label-width="120px">
        <el-form-item label="Company">
          <model-list-select
            :list="dataCompany"
            v-model="company"
            option-value="uid"
            option-text="company_name"
            placeholder="All"
            @input="getProjectData()"
          >
          </model-list-select>
        </el-form-item>
        <el-form-item label="Project">
          <model-list-select
            :list="dataProject"
            v-model="project"
            option-value="uid"
            option-text="project_name"
            placeholder="All"
            @input="projectActive"
          >
          </model-list-select>
        </el-form-item>
        <el-form-item label="Customer">
          <model-list-select
            :list="dataCustomer"
            v-model="plusuid"
            option-value="plusuid"
            option-text="membercode"
            placeholder="All"
            @input="plusuidActive"
          >
          </model-list-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAddCutomer = false">Cancel</el-button>
        <el-button type="primary" @click="submitCustomer()" :loading="submitting"
          >Confirm</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
        
<script>
import { ModelListSelect } from "vue-search-select";
import BeneficiaryPending from "./beneficiary-pending.vue";
import BeneficiaryCustomer from "./beneficiary-customer.vue";
import { getCompany } from "@/api/company";
import { getCustomerDropdown } from "@/api/customer";
import { getProjectByCompany } from "@/api/project";
import { addCustomer } from "@/api/beneficiary-monitor";
export default {
  components: {
    ModelListSelect,
    BeneficiaryPending,
    BeneficiaryCustomer,
  },
  data() {
    return {
      tabActive: "pending",
      dialogAddCutomer: false,
      submitting: false,
      company: "",
      project: "",
      plusuid: "",
      dataCompany: [],
      dataProject: [],
      dataCustomer: [],
    };
  },
  methods: {
    addCustomer() {
      this.dialogAddCutomer = true;
      this.getCompanyData();
    },
    getCompanyData() {
      getCompany().then(({ result, data }) => {
        if (result) {
          this.dataCompany = data;    
          this.getProjectData()      
        }
      });
    },
    getProjectData() {
      this.project = "";
      this.dataProject = [];
      if(this.company){
        getProjectByCompany(this.company).then(({ result, data }) => {
        if (result) {
          this.dataProject = data;
        }
      });
      }
      
    },
    getCustomerDropdown(project_uid){
      this.dataCustomer = []
      getCustomerDropdown(project_uid).then(({result, data, message})=>{
        if(result){
          this.dataCustomer = data;
        }        
      })
    },
    projectActive(value){
      this.project = value;
      this.getCustomerDropdown(this.project);
    },
    plusuidActive(value){
      this.plusuid = value;
    },

    submitCustomer(){
      var model = {
        plusuid: this.plusuid
      };
      this.submitting = true;
      addCustomer(this.project, model).then(({result, message})=>{
        this.submitting = false;
        if(result){
          this.dialogAddCutomer = false;
          this.tabActive = "customer",
          this.$refs.BeneficiaryCustomer.getBeneficiaryCustomer();
          this.$notify({
              title: "Success",
              message: `Add customer successfully`,
              type: "success",
              duration: 2000,
            });
        }else{
          this.$notify({
              title: "Error",
              message: message,
              type: "error",
              duration: 2000,
            });
        }
      })
    }
  },
  mounted(){
    
  }
};
</script>

<style lang="scss">
.beneficiary-container {
  background-color: #fff;
  .add-member-area {
    text-align: right;
    padding: 16px;
  }
}
</style>